import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, Box } from "@mui/material";
import { Card, ExpandingText, FakeText } from "@totalsoft/rocket-ui";
import { LogDetailPre } from "./LogStyles";
import { ThemedWrapper } from "components/common/SurfaceStyles";

const ItemDetailsComponent = ({ item, loading }) => {
  const { t } = useTranslation();

  return (
    <Box my={2} mx={1}>
      {loading ? (
        <FakeText onPaper lines={10} />
      ) : item.id ? (
        <Card title={`${item.level} (Id: ${item.id})`}>
          <Grid container spacing={1} pt="1">
            <Grid item xs={12} sm={6}>
              {item.correlationId ? (
                <>
                  <strong>{t("Logs.CorrelationId")}:</strong> <span>{item.correlationId}</span>
                </>
              ) : (
                ""
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <>
                <strong>{t("Logs.TimeStamp")}:</strong> <span>{item.timeStamp}</span>
              </>
            </Grid>

            {item.exception ? (
              <Grid item xs={12}>
                <strong>{t("Logs.Exception")}:</strong>
                <ThemedWrapper mt={1}>
                  <LogDetailPre>
                    <ExpandingText text={item.exception} />
                  </LogDetailPre>
                </ThemedWrapper>
              </Grid>
            ) : (
              <></>
            )}

            {item.logEvent !== "" && item.logEvent ? (
              <Grid item xs={12}>
                <strong>{t("Logs.LogEvent")}:</strong>
                <ThemedWrapper mt={1}>
                  <LogDetailPre>
                    <ExpandingText text={item.logEvent} />
                  </LogDetailPre>
                </ThemedWrapper>
              </Grid>
            ) : (
              <></>
            )}

            {item.message ? (
              <Grid item xs={12}>
                <strong>{t("Logs.Message")}:</strong>
                <ThemedWrapper mt={1}>
                  <LogDetailPre>
                    <ExpandingText text={item.message} />
                  </LogDetailPre>
                </ThemedWrapper>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </Card>
      ) : (
        <></>
      )}
    </Box>
  );
};

ItemDetailsComponent.propTypes = {
  item: PropTypes.object.isRequired,
  loading: PropTypes.bool
};

export default ItemDetailsComponent;
